import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { BLOG_CATEGORIES } from "@/data/content";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <PageHero
        overline="Blog & Resources"
        lines={["Growing Knowledge,", "Not Just Crops"]}
        subtitle="Guides, case studies, and agri-tech insights to help you grow smarter — from beginner hydroponics to government subsidy know-how."
        testId="blog-hero"
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
          <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
            {BLOG_CATEGORIES.map((b, i) => (
              <StaggerItem key={b.title}>
                <article
                  data-testid={`blog-card-${i}`}
                  className="group h-full p-8 border-r border-b border-border hover:bg-accent/40 transition-colors duration-400 flex flex-col"
                >
                  <div className="flex items-center justify-between">
                    <span className="overline text-primary">{b.tag}</span>
                    <ArrowUpRight className="w-5 h-5 text-muted-foreground transition-all duration-300 group-hover:text-primary group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                  <h3 className="mt-8 font-clash text-xl md:text-2xl leading-snug flex-1">
                    {b.title}
                  </h3>
                  <p className="mt-4 text-muted-foreground leading-relaxed">{b.excerpt}</p>
                  <span className="mt-8 overline text-muted-foreground">Coming Soon</span>
                </article>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <Reveal>
          <p className="overline text-primary">Stay in the loop</p>
          <h2 className="mt-4 font-clash text-3xl md:text-5xl tracking-tight max-w-3xl">
            New guides and case studies are on the way.
          </h2>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl">
            In the meantime, our agronomists are just a message away for any
            crop or system question you have.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
